// extracted by mini-css-extract-plugin
export default {"dark":"App_dark__sU4Z9","light":"App_light__8Fl1g","warningOverlay":"App_warningOverlay__APpyf"};